import { t } from 'i18next';
import { memo, useState } from 'react';
import FormCheck from 'react-bootstrap/FormCheck';

import { CommonInputProps } from '../InputTypes';
import '../inputs.scss';

interface Props extends CommonInputProps {
  defaultValue?: boolean;
  hookOnChange?: (value: boolean) => void;
  onInputChange?: (value: boolean) => void;
}

const InputSwitch = ({
  name,
  label,
  defaultValue,
  disabled = false,
  required = false,
  design = 'col-12',
  hookError,
  hookOnChange = () => {},
  onInputChange = () => {}
}: Props) => {
  const [value, setValue] = useState<boolean>(defaultValue!);

  return (
    <div className={design}>
      <FormCheck
        required={required}
        disabled={disabled}
        name={name}
        defaultChecked={defaultValue}
        label={t(label!)}
        type="switch"
        id="custom-switch"
        onChange={() => {
          setValue(!value);
          hookOnChange(!value);
          onInputChange(!value);
        }}
      />
      {hookError?.message && (
        <p className="customInput_error">{t(hookError?.message)}</p>
      )}
    </div>
  );
};

const MemoizeSwitch = memo(InputSwitch);
export default MemoizeSwitch;
